<template lang="pug">
.m-card
  .m-card-header-wrapper(
    :data-bs-toggle="source.items[0].marketId != 3 ? 'collapse' : null"
    :href="source.items[0].marketId != 3 ? '#collapse-match-' + index + source.items[0].marketId : null"
    role='button'
    :aria-expanded="source.items[0].marketId == 3 ? 'true' : 'false'"
    :aria-controls="'collapse-match-' + index + source.items[0].marketId"
  )
    //- small {{ source.items[0].leagueName }}
    efTimer(:source="source.items[0]")
  .m-card-body.collapse.show(
    v-if="source.items[0].marketId != 3"
    :id="'collapse-match-' + index + source.items[0].marketId"
  )
    .m-card-item
      .m-card-wrap
        .section.winners-market
          .m-label-top
            img(src='images/vgame/crown/no1.svg')
            |  {{ $t("ui.no1") }}
          .odds-group
            .col
              template(v-if="source.items[6] && source.items[6].details['ou'] && source.items[6].details['ou'][0] && source.items[6].details['ou'][0][12] != 0 && source.items[6].details['ou'][0][12] != ''")
                OddsItem(:odds="source.items[6].details['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count=0 :details="source.items[6].details" homeAway="1")
              template(v-else)
                OddsDisabled
            .col
              template(v-if="source.items[6] && source.items[6].details['ou'] && source.items[6].details['ou'][0] && source.items[6].details['ou'][0][11] != 0 && source.items[6].details['ou'][0][11] != ''")
                OddsItem(:odds="source.items[6].details['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count=0 :details="source.items[6].details" homeAway="2")
              template(v-else)
                OddsDisabled
            .col
              template(v-if="source.items[6] && source.items[6].details['oe'] && source.items[6].details['oe'][0] && source.items[6].details['oe'][0][5] != 0 && source.items[6].details['oe'][0][5] != ''")
                OddsItem(:odds="source.items[6].details['oe'][0]" idx=5 :typ="oddsType" dataType="2" label="odd")
              template(v-else)
                OddsDisabled
            .col
              template(v-if="source.items[6] && source.items[6].details['oe'] && source.items[6].details['oe'][0] && source.items[6].details['oe'][0][7] != 0 && source.items[6].details['oe'][0][7] != ''")
                OddsItem(:odds="source.items[6].details['oe'][0]" idx=7 :typ="oddsType" dataType="2" label="even")
              template(v-else)
                OddsDisabled
        .section.normal-market
          .odds-group
            .row.flex-end.border-0.p-0
              .team-name
              .m-label-betype {{ $t("m.GH_1X20") }}
              .m-label-betype {{ $t("m.GH_1X2HDP2") }}
              .m-label-betype {{ $t("m.GH_1X2HDP4") }}
            template(v-for="(x, i) in source.items.slice(0, -1)")
              .row
                .team-name
                  img.icon(:src="getImage(x)")
                  span {{ team(x, 1) }}
                template(v-if="x.details['oxt'] && x.details['oxt'][0] && x.details['oxt'][0][5] != 0 && x.details['oxt'][0][5] != ''")
                  OddsItem.col(:odds="x.details['oxt'][0]" idx=5 :typ="oddsType" dataType="2" label="raceItem")
                template(v-else)
                  OddsDisabled
                template(v-if="x.details['tw'] && x.details['tw'][1] && x.details['tw'][1][5] != 0 && x.details['tw'][1][5] != '' && x.details['tw'][1][17] == 2")
                  OddsItem.col(:odds="x.details['tw'][1]" idx=5 :typ="oddsType" dataType="2" label="raceItem")
                template(v-else)
                  template(v-if="x.details['tw'] && x.details['tw'][0] && x.details['tw'][0][5] != 0 && x.details['tw'][0][5] != '' && x.details['tw'][0][17] == 2")
                    OddsItem.col(:odds="x.details['tw'][0]" idx=5 :typ="oddsType" dataType="2" label="raceItem")
                  template(v-else)
                    OddsDisabled
                template(v-if="x.details['tw'] && x.details['tw'][0] && x.details['tw'][0][5] != 0 && x.details['tw'][0][5] != '' && x.details['tw'][0][17] == 4")
                  OddsItem.col(:odds="x.details['tw'][0]" idx=5 :typ="oddsType" dataType="2" label="raceItem")
                template(v-else)
                  template(v-if="x.details['tw'] && x.details['tw'][1] && x.details['tw'][1][5] != 0 && x.details['tw'][1][5] != '' && x.details['tw'][1][17] == 4")
                    OddsItem.col(:odds="x.details['tw'][1]" idx=5 :typ="oddsType" dataType="2" label="raceItem")
                  template(v-else)
                    OddsDisabled

</template>

<script>
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    efTimer: () => import("@/components/mobile/efight/efTimer"),
    OddsItem: () => import("@/components/mobile/main/xitem/oddsItem"),
    OddsDisabled: () => import("@/components/mobile/main/xitem/oddsDisabled")
  },
  mixins: [mixinHDPOUOdds],
  props: {
    source: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: { 
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    }
   },
  methods: {
    team(player, pos) {
      var n = player.homeTeam.split(" - ")[pos];
      return n;
    },
    getImage(x) {
      return "images/vgame/marble-characters/ball" + String(this.team(x, 0)) +".svg";
    }
  }
};
</script>